import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from './contexts/theme';
import Header from './components/Header/Header';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Skills from './components/Skills/Skills';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Experience from './components/Experience /Experience';
import './App.css';
import JellyFish from './components/JellyFish/JellyFish';

const App = () => {
  const [{ themeName }] = useContext(ThemeContext);
  const [jellyfishPositions, setJellyfishPositions] = useState([]);

  // Function to set random positions for bubbles and jellyfish
  const setRandomPositions = () => {
    const bubbles = document.querySelectorAll('.bubble');
    bubbles.forEach(bubble => {
      const randomTop = Math.random() * window.innerHeight * 0.8; // Adjust for desired height
      const randomLeft = Math.random() * window.innerWidth;
      bubble.style.top = `${randomTop}px`;
      bubble.style.left = `${randomLeft}px`;
    });

    const positions = Array.from({ length: 3 }, () => ({
      top: Math.random() * window.innerHeight * 0.8, // Adjust for desired height
      left: Math.random() * window.innerWidth
    }));
    setJellyfishPositions(positions);
  };

  // Run once on component mount
  useEffect(() => {
    setRandomPositions();
  }, []);

  return (
    <div id='top' className={`${themeName} app`}>
      <Header />

      <main>
        <About />
        <Projects />
        <Experience />
        <Skills />
        <Contact />
        <div className="bubbles-container">
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
          {jellyfishPositions.map((position, index) => (
            <JellyFish key={index} style={{ top: `${position.top}px`, left: `${position.left}px` }} />
          ))}
        </div>
      </main>

      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default App;
